<template>
  <div class="project-participants-widget">
    <div class="project-participants-widget-container">
      <projectParticipantsTable
        :projectId="projectId"
        :enableCreateTableRowAction="enableCreateTableRowAction"
        :enableDeleteTableRowAction="enableDeleteTableRowAction"
        :enableUpdateTableRowAction="enableUpdateTableRowAction"
        :searchPanelEnabled="searchPanelEnabled"
        :enableExportSettings="enableExportSettings"
      />
    </div>
  </div>
</template>
<script>
import projectParticipantsTable from '@/components/dynamicTables/tables/projectParticipantsTable'

export default {
  name: 'projectParticipantsWidget',
  components: {
    projectParticipantsTable
  },
  data() {
    return {
      enableCreateTableRowAction: false,
      enableDeleteTableRowAction: false,
      enableUpdateTableRowAction: false,
      searchPanelEnabled: false,
      enableExportSettings: false
    }
  },
  computed: {
    projectId() {
      return this.$route.params.projectId
    }
  }
}
</script>
<style scoped>
.project-participants-widget >>> h2 {
  margin-top: 5px;
  font-size: 20px;
}
.project-participants-widget {
  height: 100%;
  width: 100%;
}
.project-participants-widget .project-participants-widget-container {
  height: 100%;
  width: 100%;
  display: flex;
}
.project-participants-widget .project-participants-widget-container {
  overflow: hidden;
}
.project-participants-widget .project-participants-widget-container >>> div.ti-dynamic-table {
  height: 100%;
  width: 100%;
}
</style>
